module.exports = __webpack_public_path__ + "static/media/third_place.c5ed3cc2.svg";